var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getTemplateName(),{tag:"component",attrs:{"c-widget":_vm.conf,"c-template":_vm.templateConf}})}
var staticRenderFns = []

export { render, staticRenderFns }